import { recordApi } from '../../redux/services/record';
import type { ExportFullRecordsBackgroundJobApiProps } from '../../redux/slices/background-job-slice';
import { appDispatch } from '../../redux/store-accessors';
import { dateFormatBasedOnFilter } from '../../utils/data-transformation-utils';
import { processFieldFilters } from '../../utils/filter-url-builder-utils';
import { ExportBackgroundJobHandler } from './export-background-job.handler';

export class ExportFullRecordsBackgroundJobHandler extends ExportBackgroundJobHandler<ExportFullRecordsBackgroundJobApiProps> {
  constructor(apiProps: ExportFullRecordsBackgroundJobApiProps, details?: Record<string, unknown>) {
    super(apiProps, { ...details });
  }

  protected dispatchCreateJob() {
    const {
      formId,
      format,
      columns,
      gridOptions,
      exportFullRecordData,
      includeAttachments,
      includeLinkedRecords,
      sortDirective,
      globalHierarchyFilters,
    } = this.apiProps;
    if (exportFullRecordData) {
      if (format === 'TEMPLATE' || format === 'TEMPLATE_AND_RECORDS') {
        // The full record data export job does not work correctly for TEMPLATE or TEMPLATE_AND_RECORDS,
        // as discussed with Yulia, we should use the /records/export endpoint
        return appDispatch(
          recordApi.endpoints.createExportJob.initiate({
            formId: formId ?? '0',
            format,
            columns,
            filters: processFieldFilters(gridOptions?.fieldFilters, dateFormatBasedOnFilter),
            sortDirective,
            globalHierarchyFilters,
          })
        ).unwrap();
      } else {
        return appDispatch(
          recordApi.endpoints.createFullRecordDataExportJob.initiate({
            formId: formId ?? '0',
            format,
            columns,
            filters: processFieldFilters(gridOptions?.fieldFilters, dateFormatBasedOnFilter),
            sortDirective,
            includeAttachments,
            includeLinkedRecords,
            globalHierarchyFilters,
          })
        ).unwrap();
      }
    } else {
      throw new Error('ExportFullRecordsBackgroundJobHandler requires exportFullRecordData to be true');
    }
  }
}
